import React from 'react';
import {AuthBody, AuthImage, Container, LeftSide, RightSide} from "./auth.styles";
import AImage from '../../assets/Images/auth-bg.png'
import {useTranslation} from "react-i18next";

const Auth = ({children}) => {

    const [t] = useTranslation();
    return (
        <Container className='d-flex align-items-center justify-content-center'>
            <div className='container-xl h-100 p-0 p-xl-2'>
                <AuthBody className='row'>
                    <LeftSide className='col-12 col-xl-8 text-center'>
                        <p className='text-start mb-0'>Chat</p>
                        <h4>{t('login welcome')}</h4>
                        <AuthImage src={AImage}/>
                    </LeftSide>
                    <RightSide className='col-12 col-xl-4 d-flex flex-column'>
                        {children}
                    </RightSide>
                </AuthBody>
            </div>
        </Container>
    );
};

export default Auth;
